var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcEditBold = function SvgIcEditBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.713 4.709 5.3 16.482a.63.63 0 0 0-.123.54l.635 2.69 2.838-.035h.002a.7.7 0 0 0 .54-.258l1.484-1.858 7.632-9.553q.198-.249.305-.385l.072-.09a1.143 1.143 0 0 0-.413-1.56 1 1 0 0 1-.096-.065l-.847-.658-.892-.694-.007-.005a1.245 1.245 0 0 0-1.717.158m4.648-.413a3.14 3.14 0 0 1 .965 4.383l-.012.016-.011.015-.013.017-.025.033-.085.107-.308.387-1.086 1.36a11144 11144 0 0 1-6.548 8.196l-1.484 1.858-.782-.624.782.624-.002.001a2.7 2.7 0 0 1-2.077 1.008h-.001l-3.638.045a1 1 0 0 1-.986-.77l-.82-3.47a2.63 2.63 0 0 1 .509-2.25l9.42-11.782.014-.018a3.245 3.245 0 0 1 4.504-.445l.004.003zm-.65 3.203c.012-.015.015-.019 0 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.388 5.671a1 1 0 0 1 1.402-.184l5.452 4.187a1 1 0 0 1-1.218 1.586l-5.452-4.187a1 1 0 0 1-.184-1.402",
    clipRule: "evenodd"
  })));
};
export default SvgIcEditBold;